/**
 * PATH: apps/hr/src/pages/leave/components/types.ts
 * PURPOSE: API types and helper functions for the Leave & Attendance page
 */

export type LeaveStatusFilter = 'all' | 'pending' | 'approved' | 'rejected'
export type TimesheetStatusFilter = 'all' | 'draft' | 'submitted' | 'approved' | 'rejected'

export interface LeaveRequestApi {
  id: string
  worker_id: string
  worker_name: string
  leave_type_name: string
  start_date: string
  end_date: string
  hours_requested: number
  status: string
  notes?: string | null
  requested_at?: string
  reviewed_at?: string | null
}

export interface LeaveRequestsResponse {
  requests: LeaveRequestApi[]
}

export interface TimesheetDayApi {
  id: string
  worker_id: string
  worker_name: string
  work_date: string
  status: string
  total_hours: number
  entry_count: number
  submitted_at?: string | null
  approved_at?: string | null
}

export interface TimesheetDaysResponse {
  days: TimesheetDayApi[]
  total: number
}

export interface TimesheetStatsApi {
  pending_review: number
  approved_total: number
  approved_today: number
  rejected: number
  draft: number
  anomalies: number
}

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------

function parseISODate(value: string): Date | null {
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

export function calculateDaysInclusive(startISO: string, endISO: string): number {
  const start = parseISODate(startISO)
  const end = parseISODate(endISO)
  if (!start || !end) return 0
  const ms = end.getTime() - start.getTime()
  return Math.max(1, Math.floor(ms / (1000 * 60 * 60 * 24)) + 1)
}

export function isDateInRangeInclusive(target: Date, startISO: string, endISO: string): boolean {
  const start = parseISODate(startISO)
  const end = parseISODate(endISO)
  if (!start || !end) return false
  const t = new Date(target.getFullYear(), target.getMonth(), target.getDate()).getTime()
  const s = new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime()
  const e = new Date(end.getFullYear(), end.getMonth(), end.getDate()).getTime()
  return t >= s && t <= e
}
